


import { Button, Modal, ModalOverlay, ModalContent, ModalFooter, ModalBody, ModalCloseButton, Text, Input } from "@chakra-ui/react";
import useMobile from "../../hooks/useMobile";
import { useEffect, useState } from "react";
import InvalidInput from "../input/InvalidInput";



const TextEditModal = ({ isOpen, title, label, placeholder, onClose, onSave, initialValue, isLoading, maxLength, allowEmpty = false }: {
    title:string;
    label:string;
    placeholder:string;
    isOpen: boolean;
    onClose: () => void;
    onSave:(v : string) => void;
    initialValue : string;
    isLoading : boolean;
    maxLength?: number;
    allowEmpty?: boolean;
}) => {
    const isMobile = useMobile(600)


    const [value,setValue] = useState(initialValue)

    const [error,setError] = useState<string>("")

    const validateData = () => {
        if(value === "" && !allowEmpty){
            setError("Field cannot be empty")
            return false
        } else {
            setError("")
            return true
        }
    }

    useEffect(() => {
        
        setValue(initialValue)
    },[initialValue])


    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
                <ModalCloseButton />
                <ModalBody p='0'>
                    <Text variant='title' fontSize='2xl' fontWeight='500' mb='20px'>
                        {title}
                    </Text>

                    <Text variant='title' fontSize={isMobile ? 'md' : 'lg'} lineHeight='19px' mt='25px' mb='10px'>
                        {label}
                    </Text>
                    <Input
                        maxLength={maxLength}
                        placeholder={placeholder}
                        value={value}
                        onChange={e => setValue(e.target.value)}
                    />
                    <InvalidInput isError={error != ""} override={error}/>

                </ModalBody>
                <ModalFooter>
                    <Button variant="heavy" size='sm'
                        isLoading={isLoading}
                        onClick={() => {
                            if (validateData()) onSave(value)
                        }}
                    >Save</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default TextEditModal;
